import { OrganizationDetail } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationDetail>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const getOrganizationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getOrganizations.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getOrganizations.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getOrganizations.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getOrganizations.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default getOrganizationsReducer;
